import BetaSettings from '../../features/adverseReporting/beta/BetaSettings';
import React, { useEffect } from 'react'

import { Box, Grid, Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

import UserInfo from './UserInfo'
import ChangePassword from './ChangePassword'

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        maxWidth: 1120,
        margin: "0 auto",
        padding: theme.spacing(2, 0, 6),
        color: "#243247"
    },
}));

export default function Profile() {
    const classes = useStyles();

    useEffect(() =>{
        document.title = "Profile Settings"
    }, [])

    return (
        <Box>
            <div className={classes.root}>
                <Box mb={4}>
                    <Typography variant="h4" component="h1" style={{ fontWeight: 600, fontSize: 30, letterSpacing: -0.5 }}>Profile settings</Typography>
                    <Typography color="textSecondary" style={{ marginTop: 8 }}>Manage your account, password, and optional features.</Typography>
                </Box>
                <Grid container spacing={3} alignItems="stretch">
                    <Grid item xs={12} md={5}>
                        <UserInfo />
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <ChangePassword />
                    </Grid>
                    <Grid item xs={12}><BetaSettings /></Grid>
                </Grid>
            </div>
        </Box>
    );

}
